import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { Subject, takeUntil } from "rxjs";
import { HeaderTextService } from "./header-text.service";
import { Router } from '@angular/router';
import { TitleType } from "./header-text.types";
import { StockPanolService } from "@features/materiales/stock-panol/services/stock-panol.services";

@Component({
  selector: "header-text",
  templateUrl: "./header-text.component.html",
  encapsulation: ViewEncapsulation.None,
  exportAs: "headerText",
})
export class HeaderTextComponent implements OnInit, OnDestroy {

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _headerTextService: HeaderTextService,
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
  }

  getTitulo() {
    let titulo = this._headerTextService.getTitulo();
    if (titulo.includes("/clientes/completar-datos-cotizacion")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/clientes/completar-datos-cotizacion")).text;
    }
    if (titulo.includes("/ventas/mis-clientes/save/")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/ventas/mis-clientes/save/")).text;
    }
    if (titulo.includes("/ventas/mis-clientes/save-abertura-otra/")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/ventas/mis-clientes/save-abertura-otra/")).text;
    }
    if (titulo.includes("/ventas/mis-clientes/save-abertura-editable-chapa/")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/ventas/mis-clientes/save-abertura-editable-chapa/")).text;
    }
    if (titulo.includes("/materiales/egresos/edicion-borrador")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/materiales/egresos/edicion-borrador")).text;
    }
    if (titulo.includes("/materiales/egresos/escanear-qr")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/materiales/egresos/escanear-qr")).text;
    }
    if (titulo.includes("/materiales/egresos/vista-previa")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/materiales/egresos/vista-previa")).text;
    }
    if (titulo.includes("/materiales/movimientos-materiales")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/materiales/movimientos-materiales")).text;
    }
    if (titulo.includes("/materiales/movimientos-materiales/egresos-por-operario")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/materiales/movimientos-materiales/egresos-por-operario")).text;
    }
    if (titulo.includes("/materiales/stock-panol")) {
      let tituloPanolSel = StockPanolService.tituloPanolSel;
      return tituloPanolSel?tituloPanolSel:TitleType.find((title) => title.path === titulo)?.text;
    }
    return TitleType.find((title) => title.path === titulo)?.text;
  }

  getPath() {
    return this._headerTextService.getTitulo() != "/" ? this._headerTextService.getTitulo() : "";
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
